module.exports = __webpack_public_path__ + "static/media/dac_logo.48c1f3db.png";